export default "__VITE_ASSET__CIXaY93W__"